const UrlBase = process.env.NODE_ENV === 'development' ?
	// 'http://localhost:3000' :
	'https://api.teatrometropolitano.com' :
	'https://api.teatrometropolitano.com'
export { UrlBase }
